import { Component} from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-inversores',
  templateUrl: './inversores.component.html',
  styleUrls: ['./inversores.component.scss']
})
export class InversoresComponent {

  constructor(private loginService:LoginService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
  }

}
